import React, { FC } from "react";
import { Plan } from "services/quotes/types";
import RatesBestPlanCard from "containers/retail/sections/energy-rates-3/RatesBestPlanCard";
import { Theme } from "evcharging/app/themes";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";
import useI18n from "evcharging/hooks/useI18n";

interface DesktopBestPlansProps {
  bestPlans: Array<Plan | null>;
  handleSelectPlan(plan: Plan): void;
}

const RatesDesktopBestPlans: FC<DesktopBestPlansProps> = ({ bestPlans, handleSelectPlan }) => {
  const theme = useTheme();
  const classes = createStyles(theme);
  const { t } = useI18n();

  return (
    <div className={classes.root}>
      {bestPlans.map((plan) => {
        return (
          <div key={plan.planId}>
            {plan ? (
              <RatesBestPlanCard plan={plan} onSelect={handleSelectPlan} />
            ) : (
              <div>{t('rates.no-plan')}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 24,
    '& > div': {
      width: '100%',
    },
  }),
});


export default RatesDesktopBestPlans;
